// TODO: Remove the any type and replace with a proper type.
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { DateService } from './date.service';
import { EventsService } from './events.service';
import { GeolocationService } from './geolocation.service';
import { ShuttlesService } from './shuttles.service';
import { UtilsService } from './utils.service';
import { TripActualLocationService } from './tripActualLocation.service';
import type { TCoordinate, TTripActualPosition, TShuttle, TVector } from '@shared/models';
import { Constants } from '@shared/models';

// const LATITUDE_EPSILON  = 0.000138;		// Another .000138 difference along the latitude is 50 feet.
// const LONGITUDE_EPSILON = 0.000166;     // Another .000166 difference along the longitude is 50 feet.
const MAX_ACTUAL_POSITION_BUFFER_SIZE = 100;

@Injectable({
    'providedIn': 'root'
})
export class ShuttleMovementService {
    // private vectors: TVector[]; // Map<string, TVector>;
    // private saveNavigationLocationFrequency: number;
    // private dealershipCoordinate;
    // private saveTrackerLocationFrequency = 5;
    // private actualTripSequenceNum = 0;
    // private lastVectorSaveTime!: TTimestamp;
    // private lastTripSaveTime!: TTimestamp;
    private watchSubscription!: Subscription;
    private processingWatch = false;
    private currentLegIdx = 0;
    private tripUid!: string;
    private actualPositions: TTripActualPosition[] = [];

    // private sessionService: SessionService, , private settingsService: SettingsService
    // 
    constructor(private geolocationService: GeolocationService, private utilsService: UtilsService,
        private tripActualLocationService: TripActualLocationService, private eventsService: EventsService,
        private dateService: DateService, private shuttlesService: ShuttlesService) {
    }

    public initialize(): void {
        // const promise = new Promise(async (resolve, reject) => {
        // this.vectors = await this.vectors Service.getAll();
        // const settings = await this.settingsService.get();
        // this.saveNavigationLocationFrequency = settings.misc.saveNavigationLocationFrequency;
        // resolve(true);
        // });
        // return promise;
    }

    // public getVectors() {
    //     return this.vectors;
    // }

    public async startLocationTracking(tripUid: string, shuttle: TShuttle): Promise<void> {
        let newShuttle: TShuttle;
        this.tripUid = tripUid;
        // this.actualTripSequenceNum = 0;
        this.tripActualLocationService.resetSeqeunceNumber();

        this.shuttlesService.resetVector(shuttle);

        this.processingWatch = false;
        // TODO: This is a temporary fix.  We need to use the observable returned from getPositionObservable.
        // This will allow us to unsubscribe from the observable when the trip is completed.
        //
        // const watchObservable = this.geolocationService.getPositionObservable(async (travelInfo: any) => {
        this.geolocationService.getPositionObservable(async (travelInfo: any) => {
            // this.watchSubscription = watchObservable.subscribe(async (travelInfo: any) => {

            // console.warn('In startLocationTracking.travelInfo() = ', travelInfo);

            if (!this.processingWatch) {
                // Toggle processingWatch to avoid two travelInfo's from being processed at the same time.
                this.processingWatch = true;
                newShuttle = await this.calculateNewVectorPosition(shuttle, travelInfo);

                // Determine if we should save the vector, if so save it.
                const save = this.shouldVectorBeSaved(shuttle.vector, travelInfo);
                if (save) {
                    await this.shuttlesService.update(newShuttle);
                    // this.lastVectorSaveTime = this.dateService.now();
                }

                // Determine if we should save the actual trip location.
                // const saveTrip = this.shouldActualLocationBeSaved(vector, travelInfo);
                const saveTrip = this.shouldActualLocationBeSaved(newShuttle.vector, travelInfo);
                if (saveTrip) {
                    // Save the vector details in our trip so historical tracking can see where the shuttle went.
                    const position: TTripActualPosition = {
                        'dateTime': this.dateService.now(),
                        'coordinate': newShuttle.vector.currentLocation!,
                        'speed': newShuttle.vector.speed!,
                        'heading': newShuttle?.vector.heading,
                        'legIndex': this.currentLegIdx
                    };
                    this.actualPositions.push(position);

                    if (this.actualPositions.length >= MAX_ACTUAL_POSITION_BUFFER_SIZE) {
                        await this.flushActualLocations();
                    }

                    // const msg = `(${newVector.currentLocation.latitude}, 
                    // ${newVector.currentLocation.latitude}); (${this.actualPositions.length})`;
                    // NavigationPage4 has subscribed to this debug event. Publishing these variables will help with debugging.
                    const obj = { 'location': newShuttle.vector.currentLocation, 'index': this.actualPositions.length };

                    // #type-mismatch
                    this.eventsService.publish(Constants.EVENT_DEBUG_MESSAGE, obj);
                    // this.lastTripSaveTime = this.dateService.now();
                }

                this.processingWatch = false;
            }
        });
    }

    private async flushActualLocations(): Promise<void> {
        await this.tripActualLocationService.addCurrentLocationToTrip(this.tripUid,
            this.currentLegIdx, this.actualPositions);
        this.actualPositions = [];
    }

    public getTotalActualPositions(): number {
        return this.tripActualLocationService.getActualPositionsRunningTotal();
    }

    public setCurrentLeg(legIndex: number): void {
        this.currentLegIdx = legIndex;
    }

    private shouldVectorBeSaved(vector: TVector, currentLocation: any): boolean {
        // console.log(vector, currentLocation);
        return true;
        // const now = this.dateService.now();
        // let saveIt = false;
        // const numSecondsSinceVectorSaved = now.diff(this.lastVectorSaveTime, 'seconds');

        // const currentLatitude  = currentLocation.coords.latitude;
        // const currentLongitude = currentLocation.coords.longitude;

        // Compute the time delta from .
        // let timeDelta = mom-ent(currentLocation.timestamp).diff(vector.previousTime, 'seconds');

        // Compute the distance delta from where we were to where we are now.
        // const latitudeDelta = Math.abs(currentLatitude - vector.previousLocation.latitude);
        // const longitudeDelta = Math.abs(currentLongitude - vector.previousLocation.longitude);

        // If we moved more than fifty feet along the latitude or longitude or
        // then update our position in firebase.  Ignore the hypotenuse.
        //     if (latitudeDelta > LATITUDE_EPSILON || longitudeDelta > LONGITUDE_EPSILON) {
        //         saveIt = true;
        //     } else if (numSecondsSinceVectorSaved >= this.saveTrackerLocationFrequency) {
        //        saveIt = true;
        //    }

        //     return saveIt;
    }

    private shouldActualLocationBeSaved(vector: TVector, currentLocation: any): boolean {
        // If we are in the exact same spot we were a moment ago, don't bother saving a new vector.

        return true;
        // const currentLatitude  = currentLocation.coords.latitude;
        // const currentLongitude = currentLocation.coords.longitude;

        // // Compute the time delta from .
        // let timeDelta = mom-ent(currentLocation.timestamp).diff(vector.previousTime, 'seconds');

        // // Compute the distance delta from where we were to where we are now.
        // let latitudeDelta = Math.abs(currentLatitude - vector.previousLocation.latitude);
        // let longitudeDelta = Math.abs(currentLongitude - vector.previousLocation.longitude);

        // If we moved more than fifty feet along the latitude or longitude or
        // if more than then update our position in firebase.  Ignore the hypotenuse.
        // if (latitudeDelta > LATITUDE_EPSILON || longitudeDelta > LONGITUDE_EPSILON) {
        // const deltaTimeMilliSecs = vector.currentTime - (isNaN(vector.previousTime) ? 0 : vector.previousTime);
        // const now = this.dateService.now();
        // let saveIt = false;
        // const numSecondsSinceTripSaved = now.diff(this.lastTripSaveTime, 'seconds');

        // if (numSecondsSinceTripSaved >= this.saveNavigationLocationFrequency) {
        //     saveIt = true;
        // }

        // return saveIt;
    }

    private async calculateNewVectorPosition(shuttle: TShuttle, travelInfo: any): Promise<TShuttle> {
        const vector: TVector = shuttle.vector;
        vector.currentTime = travelInfo.timestamp;

        if (travelInfo.coords.speed) {
            const metersPerSecond = travelInfo.coords.speed;
            vector.speed = this.utilsService.calculateSpeedFromMetersPerSecond(metersPerSecond);
        } else {
            vector.speed = { 'mph': 0, 'kph': 0 };
        }

        const currentLocation: TCoordinate = {
            'latitude': travelInfo.coords.latitude,
            'longitude': travelInfo.coords.longitude
        };
        vector.currentLocation = currentLocation;
        vector.heading = travelInfo.coords.heading || 0;
        // vector.distanceFromDealership = this.utilsService.calculateDistance(vector.currentLocation, this.dealershipCoordinate);
        vector.previousLocation = vector.currentLocation;
        vector.previousTime = vector.currentTime;

        return shuttle;
    }

    // This is called by: NavigationPage4 when all the tickets have been completed.
    public async stopLocationTracking(vector: TVector) {
        // console.log(vector);
        if (this.watchSubscription) {
            this.watchSubscription.unsubscribe();
        }
        await this.flushActualLocations();
        // this.vectors.delete(vector.shuttle.uid);
    }

    public async moveShuttle1Mile(shuttle: TShuttle) {
        const vector = shuttle.vector;
        const latitudeOffset = 0.000726;		// Travelling at 60mph along the latitude, you would move this far in 3 seconds
        const longitudeOffset = 0.000877;		// Travelling at 60mph along the longitude, you would move this far in 3 seconds
        const mile = 20;

        vector.currentLocation!.latitude += latitudeOffset * mile;
        vector.currentLocation!.longitude += longitudeOffset * mile;
        // vector.distanceFromDealership = this.utilsService.calculateDistance(vector.currentLocation, this.dealershipCoordinate);

        vector.speed = this.utilsService.calculateSpeed(vector.previousLocation!, vector.currentLocation!, 1);
        // ptb            vector.nearbyAddress = await this.getNearbyAddress(vector);
        await this.shuttlesService.update(shuttle);
    }
}


/*
      // This routine is only for debugging purposes.  If we are running in real mode then simply
      // return the incoming coordinate.  When debugging at the desk however, I want to navigate
      // along a known route so that when I issue the command for a pickup request the I can more
      // easily determine and debug the proper insertion point along the already established route.
      function debuggingRoute(vector, currentcoordinate) {
          if (!SessionFactory.isDebugMode()) {
              return currentcoordinate;
          }

          // In debug mode we will return a defined route.
    // 'Condo'                  '20212 Fanchon Lane, Canyon Country, Ca. 91351',          34.420514, -118.488589
    // 'Home Depot'             '20642 Golden Triangle Road, Santa Clarita, Ca. 91351'    34.419174, -118.497052
    // 'Mountasia'              '21516 Golden Triangle Rd, Santa Clarita, CA 91350'       34.415452, -118.511612
    // 'McDonalds'              '23110 Valencia Blvd, Valencia, CA 91355'                 34.422378, -118.541789
    // 'Frontier'               '23621 Creekside Rd.  Valencia Ca. 91355'                 34.418922, -118.554037
    // 'Valencia Library'       '23743 Valencia Blvd. Santa Clarita Ca. 91355'            34.415577, -118.550768
    // 'Corner Bakery'          '24290 Valencia Blvd, Valencia, CA 91355'                 34.412861, -118.559267

          let debuggingRoutes = [
              {'name': 'Condo',            'latitude': 34.420514, 'longitude': -118.488589},
              {'name': 'Home Depot',       'latitude': 34.419174, 'longitude': -118.497052},
              {'name': 'Mountasia',        'latitude': 34.415452, 'longitude': -118.511612},
    //          {'name': 'McDonalds',        'latitude': 34.422378, 'longitude': -118.541789}, // Used for pickup request location
              {'name': 'Frontier',         'latitude': 34.418922, 'longitude': -118.554037},
              {'name': 'Valencia Library', 'latitude': 34.415577, 'longitude': -118.550768},
              {'name': 'Corner Bakery',    'latitude': 34.412861, 'longitude': -118.559267}
          ];

          // The route is started in navigation.  Six times through the loop at three second each
          // gives me 18 seconds between each ticket to issue the insert pickup request command
          // and do the debugging.
          vector.debug = vector.debug || {'num': 0, 'idx': 0};
          if (vector.debug.num < 6) {
              ++vector.debug.num;
          } else {
              ++vector.debug.idx;
              vector.debug.num = 0;
          }

          // See if we need to start at the beginning of the route - Condo.
          if (vector.debug.idx === debuggingRoutes.length) {
              vector.debug.idx = vector.debug.num = 0;
          }

          let coordinate = debuggingRoutes[vector.debug.idx];
          return coordinate;
      }
      */

/* ptb
    private getNearbyAddress(vector) {
        const promise = new Promise(async (resolve, reject) => {
            if (vector.distanceFromDealership.miles < 0.10) {
                resolve('At Dealership');
            } else {
                const coord = vector.currentLocation;
                const obj: any = await this.geocoderService.convertLatLngToStreetAddress(coord);
                resolve(obj.formattedAddress);
            }
        });
        return promise;
    }
    */


// private async saveupdateCurrentPosition(vector: TVector, currentLocation: any) {
//     const currentLatitude  = currentLocation.coords.latitude;
//     const currentLongitude = currentLocation.coords.longitude();

//     // Compute the time delta from .
//     let timeDelta = mom-ent(currentLocation.timestamp).diff(vector.previousTime, 'seconds');

//     // Compute the distance delta from where we were to where we are now.
//     let latitudeDelta = Math.abs(currentLatitude - vector.previousLocation.latitude);
//     let longitudeDelta = Math.abs(currentLongitude - vector.previousLocation.longitude);

//     // If we moved more than fifty feet along the latitude or longitude or
//     // if more than then update our position in firebase.  Ignore the hypotenuse.
//     if (latitudeDelta > LATITUDE_EPSILON || longitudeDelta > LONGITUDE_EPSILON) {
//         vector.currentTime = this.dateService.now();
//         const deltaTimeSecs = vector.currentTime - vector.previousTime;
//         vector.previousTime = vector.currentTime;

//         const currentCoordinate: TCoordinate = {
//             'latitude': currentLocation.coords.latitude,
//             'longitude': currentLocation.coords.longitude
//         };

//         vector.previousLocation = vector.currentLocation;
//         vector.currentLocation = currentLocation.coords;
//         vector.speed = this.utilsService.calculateSpeed(vector.previousLocation, currentCoordinate, deltaTimeSecs);
//         vector.distanceFromDealership = this.utilsService.calculateDistance(vector.currentLocation, this.dealershipCoordinate);

//         console.log('This vector bombs = ', vector);
//         await this.shuttlesService.update(vector);

//         // Save our current location to the tripdatabase.
//         // await this.saveTripLocation(vector);
//     }
//     return vector;
// }

